import React, { Component } from "react";
import pointsList from "./PointsList";
import DataMapping from "./DataMapping";
import Popup from "reactjs-popup";
import Arrow from "../Animation/Arrow";

const GrafanaPopup = (props) => {
  let onColor = "#FFFFFF";
  let errorStage = "Error stage";
  switch (props.pointsList.measurement) {
    case "HV-001":
    case "HV-004":
    case "HV-007":
    case "HV-003":
    case "HV-002":
    case "HV-005":
    case "HV-006":
    case "HV-008":
    case "HV-013":
    case "HV-010":
    case "HV-012":
    case "HV-011":
    case "Fan":
    case "Burning":
    case "HV-009":
      if (props.result == "OFF") onColor = "#F54242";
      break;
  }
  return (
    <Popup
      trigger={(open) => (
        <div
          className="main-text-div"
          style={{ textAlign: "center", color: onColor, opacity: 0.9 }}
        >
          <span style={{ margin: "auto", display: "table" }}>
            <b>{props.result}</b>
          </span>
        </div>
      )}
      position={props.position}
      contentStyle={{
        width: "auto",
        backgroundColor: "#000000",
        border: "1px solid rgba(29,27,27,0.75)",
        borderRadius: "5px",
        boxShadow: "1px 1px 5px 0 rgba(51, 50, 50, .75)",
      }}
      arrowStyle={{
        background: "#C75E24",
      }}
    >
      <div className="content-div">
        <iframe
          src={
            "https://iot.research.hamk.fi/visu/d-solo/Kogkmv2Wz/venect-measurements?orgId=4&from=now-6h&to=now&panelId=" +
            props.pointsList.panelId
          }
          title={props.pointsList.measurement}
          width="450"
          height="200"
          frameborder="0"
        />
      </div>
    </Popup>
  );
};

const Container = (props) => {
  const { position, measurement } = props.pointsList;
  var result = DataMapping({
    id: props.pointsList.measurement,
    message: props.message,
  });

  let containerStyle =
    measurement.includes("AK_P") ||
    measurement.includes("P1") ||
    measurement.includes("P2") ||
    measurement.includes("Error") ||
    measurement.includes("Burning")
      ? {
          position: "absolute",
          top: `${position.top}%`,
          left: `${position.left}%`,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
        }
      : {
          position: "absolute",
          top: `${position.top}%`,
          left: `${position.left}%`,
        };
  // var result = DataMapping({
  //   id: props.pointsList.measurement,
  //   message: props.message,
  // });
  // choose whether chips are under or beside measurements ID
  return (
    <div style={containerStyle}>
      <div
        style={{ textAlign: "center", color: "#FFFFFF", fontSize: "0.777vw" }}
      >
        {measurement == "Burning"
          ? "Burning stage"
          : measurement == "Error"
          ? "Status"
          : measurement}
      </div>
      {(measurement.includes("HV-001") ||
        measurement.includes("HV-002") ||
        measurement.includes("HV-003") ||
        measurement.includes("HV-004") ||
        measurement.includes("HV-005") ||
        measurement.includes("HV-006") ||
        measurement.includes("HV-007") ||
        measurement.includes("HV-008") ||
        measurement.includes("HV-009")) && <br />}
      {(measurement.includes("Fan") ||
        measurement.includes("Burning") ||
        result !== "ON") && <GrafanaPopup {...props} result={result} />}
      {measurement.includes("HV") && result !== "OFF" && (
        <Arrow waterFlow={props.pointsList.waterFlow} />
      )}
    </div>
  );
};

// map all points (from pointsList) with html's style in Container, to display on loop
export default function Points(props) {
  const points = pointsList.map((e) => (
    <Container key={e.measurement} pointsList={e} message={props.messages} />
  ));
  return points;
}
